export class PlayerWatchPercentage {
  constructor(videoDuration, handleWatching){
    this.videoDuration = videoDuration;
    this.handleWatching = handleWatching;
    this.watchedSeconds = [];
    this.lastSentPercentage = 0;
  }

  register(totalPreviousClipsDuration, currentTime){
    var secondInVideo = Math.floor(totalPreviousClipsDuration) + Math.max(Math.ceil(currentTime), 1);
    this.watchedSeconds[secondInVideo] = true;

    if (this.isSend()) {
      if (this.isWatching()) {
        this.handleWatching();
      }
      this.lastSentPercentage = this.sentPercentage();
    }
  }

  isSend(){
    return (this.currentPercentage() - this.lastSentPercentage) >= 5;
  }

  isWatching(){
    return (this.currentPercentage() <= 100);
  }

  sentPercentage(){
    return Math.floor(this.currentPercentage() / 5) * 5;
  }

  currentPercentage(){
    return Math.floor(this.watchedDuration() / this.videoDuration * 100);
  }

  watchedDuration(){
    return Object.keys(this.watchedSeconds).length;
  }
}


